module.exports = __webpack_public_path__ + "img/Pegelrechnung2.87dd7035.jpg";